import { Platform } from "react-native";
import {
  BILLING_PAYMENTS_ROUTE,
  CONTACT_AGENT_ROUTE,
  DELETE_ACCOUNT_ROUTE,
  DOCUMENTS_INFO_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  MAKE_CLAIM_ROUTE,
  PDF_VIEWER_ROUTE,
  POLICY_ACTION_ROUTE,
  POLICY_LISTING_ROUTE,
  REGISTER_ROUTE,
  RESET_PASSWORD_ROUTE,
} from "../../src/navigation/NavigationConstants";
import { theme } from "../../src/theme/theme";
import Config from "react-native-config";
import {
  ABOUT_ICON,
  BLOG_ICON,
  DELETE_ICON,
  FAQ_ICON,
  PRIVACY_ICON,
  RESET_ICON,
  SIGNOUT_CUSTOM_ICON,
  SIGNOUT_ICON,
  TERMS_ICON,
} from "../../src/resources/IMAGES";

export const AppJSON = {
  NAME: "TypTapPolicyholder",
  DISPLAY_NAME: "TypTap Policies",
};
export const FORMAT_TYPE = {
  DEFAULT: "default",
  NUMBER: "Number",
  TEXT: "Text",
  PERCENTAGE: "Percentage",
  UNDEFINED: "undefined",
  INTEGER: "integer",
  CURRENCY: "currency",
};

export function getCompanyName() {
  const companyName =
    (Platform.OS == "web"
      ? process.env.REACT_APP_POLICY_COMPANY
      : Config.REACT_APP_POLICY_COMPANY) ?? "typtap";
  return companyName?.toUpperCase();
}
export const isQRVisible = (): boolean => {
  return Platform.OS == "web" && process.env.REACT_APP_IS_QR_VISIBLE === "true";
};

// ----------------
// Local store keys
// ----------------
export default {
  Prefs: {
    ACCESS_TOKEN: "access_token",
  },
  Events: {
    LOGIN_SUCCESS: "login_success",
  },
  User: {
    ACCESS_TOKEN: "",
    USER_DETAILS: "@user_details",
  },
  LocalStoreConstant: {
    ACCESS_TOKEN: "@access_token",
    REFRESH_TOKEN: "@refresh_token",
    APP_UPDATE_SKIPPED: "@app_update_skipped",
    ARRAY_POLICY_LIST: "@array_policy_list",
    SELECTED_POLICY: "@selected_policy",
    SELECTED_POLICY_NUMBER: "@selected_policy_number",
    POLICY_ACTIONS_ARRAY_POLICY_LIST: "@policy_actions_array_policy_list",
    POLICY_ACTIONS_SELECTED_POLICY: "@policy_actions_selected_policy",
    IS_RELOADING: "@IS_RELOADING",
    IS_DATA_LOADED_ONCE: "@IS_DATA_LOADED_ONCE",
    SHOW_LOGIN_POPUP: "@SHOW_LOGIN_POPUP",
    CURRENT_LOADED_SCREEN: "@CURRENT_LOADED_SCREEN",
    HAS_HARMONY_ACCESS: "@has_harmony_access",
    REACT_APP_ENVIRONMENT: "@REACT_APP_ENVIRONMENT",
    GRANT_ACCESS_API_COUNTER: "@GRANT_ACCESS_API_COUNTER",
    DEVICE_TOKEN: "@DEVICE_TOKEN",
    DEVICE_TOKEN_USER_ID: "@DEVICE_TOKEN_USER_ID",
    IS_COMING_FROM_NOTIFICATION: "@IS_COMING_FROM_NOTIFICATION",
    BADGE_COUNT: "@BADGE_COUNT",
    DELETE_ACCOUNT: "@DELETE_ACCOUNT",
    DEVICE_UPLOADED: "@DEVICE_UPLOADED",
  },
};

// ----------------
// Generic String literals and palceholder statements
// ----------------
export const ScreenNameList = {
  login: "Login",
  choosePolicy: "CHOOSE A POLICY ",
  contactAgent: "Contact My Agent",
  documentInfo: "Docs & Info",
  makeClaim: "Report a Claim",
  policyActions: "Policy Actions",
  policyActionsBlockView: "Policy Actions Block View",
  policyActionsListView: "Policy Actions List View",
  makePayment: "Make A Payment",
  pdfViewer: "Document Viewer",
  billingPayments: "Billing & Payments",
  register: "Register",
  notificationCenter: "Notification Center",
  resetPassword: "Reset Password",
  regsiterSuccessView: "Register Success",
  forgotPassword: "Forgot Password",
  deleteAccount: "Delete Account",
  accountDeletion: "Account Deletion", // public url
};

export const NavigationScreenName = {
  login: LOGIN_ROUTE,
  choosePolicy: POLICY_LISTING_ROUTE,
  contactAgent: CONTACT_AGENT_ROUTE,
  documentInfo: DOCUMENTS_INFO_ROUTE,
  makeClaim: MAKE_CLAIM_ROUTE,
  policyActions: POLICY_ACTION_ROUTE,
  policyActionsBlockView: "PolicyActionsBlockView",
  policyActionsListView: "PolicyActionsListView",
  pdfViewer: PDF_VIEWER_ROUTE,
  billingPayments: BILLING_PAYMENTS_ROUTE,
  register: REGISTER_ROUTE,
  resetPassword: RESET_PASSWORD_ROUTE,
  forgotPassword: FORGOT_PASSWORD_ROUTE,
  deleteAccount: DELETE_ACCOUNT_ROUTE,
};
export const isNavigationScreen = (screenName: string): boolean => {
  if (!screenName || !NavigationScreenName) return false;
  const navigationScreenValues = Object.values(NavigationScreenName);
  return (
    Array.isArray(navigationScreenValues) &&
    navigationScreenValues?.includes(screenName)
  );
};

// ----------------
// Screen specfic strings
// ----------------

export const BillingConstants = {
  premium: "Premium",
  currentPremium: "Current Premium",
  initialPremium: "Initial Premium",
  balanceDue: "Balance Due",
  billingInformation: "Billing Information",
  nextPayment: "Next Payment",
  paymentDue: "Payment Due",
  billPlan: "Bill Plan",
  billTo: "Bill To",
  payments: "Payments",
  paymentsReceived: "Payments Received",
  paymentStatusLabel: "Payments may take up to 48 hours to reflect.",
  paymentDescription: "Once you make a payment, it’ll appear here.",
};

// Docs and Info
export const DocsInfoConstants = {
  policyholder: "Policyholder",
  policyDetails: "Policy Details",
  policyholderName: "Policyholder Name",
  policyEffectiveDate: "Policy Effective Date",
  policyExpirationDate: "Policy Expiration Date",
  phone: "Phone",
  mailingAddress: "Mailing Address",
  email: "Email",
  coverageLimits: "Coverage Limits",
  surchargesDiscounts: "Surcharges/Discounts",
  deductibles: "Deductibles",
};

// FAQ 

export const FAQConstants = {
  howCanWeHelp: "How can we help?",
} as const;

// ----------------
// App Enums
// ----------------
export const RegisterUseCase = {
  none: 0,
  newUser: 1,
  existingUserWithNoAccess: 2,
  existingUser: 3,
};

export const PolicyStatusColorCode = {
  "Policy Issued": theme.colors.policyStatus.primary,
  "In Force": theme.colors.policyStatus.primary,
  "Fully Paid": theme.colors.policyStatus.primary,
  "Partially Paid": theme.colors.policyStatus.primary,
  "Partially Paid - Payment Due": theme.colors.policyStatus.primary,
  "Cancellation Notice Sent": theme.colors.policyStatus.secondary,
  "Voluntary Non Renewal": theme.colors.policyStatus.secondary,
  "Pending Voluntary Cancellation": theme.colors.policyStatus.secondary,
  "Pending Underwriting Cancellation": theme.colors.policyStatus.secondary,
  "Pending Underwriting Non-Renewal": theme.colors.policyStatus.secondary,
  "Cancelled Voluntary": theme.colors.policyStatus.tertiary,
  "Cancelled - Non Payment": theme.colors.policyStatus.tertiary,
  "Cancelled - Underwriting": theme.colors.policyStatus.tertiary,
  "Policy Expired": theme.colors.policyStatus.tertiary,
  Cancelled: theme.colors.policyStatus.tertiary,
  "Not in Force": theme.colors.policyStatus.tertiary,
};

export const getPolicyStatus = (policyStatus: any) => {
  //Get policy status based on predefined list
  policyStatus = isNaN(policyStatus)
    ? policyStatus
    : // @ts-ignore
      PolicyStatus[`${policyData.status}`];
  if (policyStatus === null || typeof policyStatus === "undefined") {
    policyStatus = "";
  }
  return policyStatus;
};
export const APIService = {
  harmony: 0,
  exzeo: 1,
  notificationService: 2,
  other: 3,
};

export const NotificationType = {
  payment: 1,
  docs: 2,
  hurricane: 3,
  generic: 4,
};

export const AlertType = {
  noAlert: 0,
  bottomToast: 1,
  centerMessage: 2,
  centerAlert: 3,
};

export const getCarrierName = () => {
  const companyName =
    (Platform.OS == "web"
      ? process.env.REACT_APP_POLICY_CARRIER
      : Config.REACT_APP_POLICY_CARRIER) ?? "harmony";
  return companyName?.toLowerCase();
};

export const PAYMENT_KEYS = {
  onload: "portalOne.load",
  onUnLoad: "portalOne.unload",
  onError: "portalOne.error",
  onPaymentComplete: "portalOne.paymentComplete",
  onPaymentCanceled: "portalOne.paymentCanceled",
  onPaymentStarted: "paymentStarted",
  sourceName: "PolicyholderApp",
  userRole: "Insured",
  paymentCategory: "UserSelect",
  feeContext: "PaymentWithFee",
  amountContext: "SelectOrEnterAmount",
  clientReferenceData2: "INHO",
  onScriptLoaded: "scriptLoaded",
  onScriptLoadError: "scriptLoadError",
};
export const SIGN_OUT_REGEX = /sign\s*out/i;

export const QR_WIDTH_CONSTANTS = {
  largeDesktop: 1512,
  desktopDevice: 900,
  tablets: 768,
  isMobile: 400,
  smallDevice: 300,
};

export const ONE_INC_URL = "oneinc.com/company/certification";

export const isGradientAllowed =
  (Platform.OS == "web"
    ? process.env.REACT_APP_IS_GRADIENT_ALLOWED
    : Config.REACT_APP_IS_GRADIENT_ALLOWED) ?? false;

export const isOpaqueStripeDisabled =
  (Platform.OS == "web"
    ? process.env.REACT_APP_IS_OPAQUE_STRIPE_DISABLE
    : Config.REACT_APP_IS_OPAQUE_STRIPE_DISABLE) ?? false;

export const isCustomDrawerEnabled =
  (Platform.OS == "web"
    ? process.env.REACT_APP_IS_CUSTOM_DRAWER_ENABLED
    : Config.REACT_APP_IS_CUSTOM_DRAWER_ENABLED) ?? false;

export const isActionTabsLayout = () => {
  let configData = process.env.REACT_APP_POLICY_ACTION_TYPE
    ? process.env.REACT_APP_POLICY_ACTION_TYPE
    : Config.REACT_APP_POLICY_ACTION_TYPE;
  return configData == "actionTabs";
};

export const BRAND_NAMES = {
  TYPTAP: "TYPTAP",
  HCPCI: "HCPCI",
  TAILROW: "TAILROW",
  PRAXIS: "PRAXIS",
  CORE: "CORE",
}